import { SYSTEMS } from '../../constants/systems';
import { useTemperature } from '../../hooks/useTemperature';
import {
  ConsumptionImgWrapper,
  ConsumptionTitleG,
  ConsumptionTitleS,
  ConsumptionTitleWrapper,
  ConsumptionUnit,
  ConsumptionWrapper,
  Img,
  SectionConsumption,
  SectionMain,
  SectionMainContentClose,
  SectionSub,
  ShutOffButton,
} from './bodyStyles';
import ElectricControls from './ElectricControls';
import GasControls from './GasControls';
import StatusLights from './StatusLights';
import {
  DisplayTempWrapper,
  DisplayTempWrapperTop,
  ExpandButton,
  ExpandButtonHole,
  ExpandButtonTop,
  InfoImag,
  InfoTitle,
  InfoWrapperA,
  InfoWrapperB,
  SectionButton,
  SectionInfo,
  SectionTemperature,
} from './statusStyles';

const shown = (isOff, on, image) => (isOff || !on ? image.none : image.on);
const GP = { on: '/images/gp-battery.svg', none: '/images/battery-none.svg' };
const EBP = { on: '/images/ebp-battery.svg', none: '/images/battery-none.svg' };
const WIFI = { on: '/images/wifi-active.svg', none: '/images/wifi-none.svg' };

/**
 * The desktop card while collapsed: shut-off, the quick program controls,
 * consumption, temperatures, status lights, badges and the expand button.
 * `card` is useMachineCard's result plus system, consumption and temps.
 */
const MachineSummary = (card) => {
  const { system, device, readOnly, consumption, temps, toggleShutOff, expand } = card;
  const { isOff, isFaults, isGp, isEbp, isWifi } = device;
  const { isF, unit } = useTemperature();
  const Controls = SYSTEMS[system].isGas ? GasControls : ElectricControls;

  return (
    <SectionMainContentClose isFaults={isFaults} isOff={isOff}>
      <SectionMain isOff={isOff}>
        <ShutOffButton onClick={toggleShutOff} isOff={isOff} isLocked={readOnly}>
          <Img isShutOff src={isOff ? '/images/turn-on.svg' : '/images/shut-off.svg'} />
        </ShutOffButton>
        <Controls {...card} />
      </SectionMain>

      <SectionSub isOff={isOff}>
        <SectionConsumption isOff={isOff}>
          <ConsumptionWrapper isOff={isOff}>
            <ConsumptionImgWrapper>
              <Img
                energy
                src={
                  isOff
                    ? '/images/MC-energy-consumption-disabled.svg'
                    : '/images/MC-energy-consumption.svg'
                }
              />
            </ConsumptionImgWrapper>
            <ConsumptionTitleS isOff={isOff} first>
              total {consumption.source}
            </ConsumptionTitleS>
            <ConsumptionTitleS isOff={isOff}>consumption</ConsumptionTitleS>
            <ConsumptionTitleWrapper>
              <ConsumptionTitleG isOff={isOff}>{consumption.value}</ConsumptionTitleG>
              <ConsumptionUnit isOff={isOff}>{consumption.unit}</ConsumptionUnit>
            </ConsumptionTitleWrapper>
          </ConsumptionWrapper>
        </SectionConsumption>

        <SectionTemperature isOff={isOff}>
          <DisplayTempWrapper isOff={isOff}>
            <DisplayTempWrapperTop isOff={isOff}>
              set temp. {temps.setTemp ? temps.setTemp : '---'}
              {isF ? '°F' : '°C'}
            </DisplayTempWrapperTop>
          </DisplayTempWrapper>
          <DisplayTempWrapper isOff={isOff}>
            <DisplayTempWrapperTop isOff={isOff}>
              cur. temp.{' '}
              {isOff ? '---' : temps.currentTemp ? `${temps.currentTemp}` : '---'}
              {unit}
            </DisplayTempWrapperTop>
          </DisplayTempWrapper>
        </SectionTemperature>

        <StatusLights system={system} device={device} />

        <SectionInfo isOff={isOff}>
          <InfoWrapperA isOff={isOff}>
            <InfoTitle state={isGp} title='gp' isOff={isOff}>
              gp
            </InfoTitle>
            <InfoImag src={shown(isOff, isGp, GP)} />
          </InfoWrapperA>
          <InfoWrapperA isOff={isOff}>
            <InfoTitle title='ebp' state={isEbp}>
              ebp
            </InfoTitle>
            <InfoImag src={shown(isOff, isEbp, EBP)} />
          </InfoWrapperA>
          <InfoWrapperB isOff={isOff}>
            <InfoImag src={shown(isOff, isWifi, WIFI)} />
          </InfoWrapperB>
          <InfoWrapperB isOff={isOff}>
            <InfoImag
              src={
                isOff
                  ? '/images/fault-sm-disabled.svg'
                  : isFaults
                    ? '/images/fault-sm-active.svg'
                    : '/images/fault-sm.svg'
              }
            />
          </InfoWrapperB>
        </SectionInfo>

        <SectionButton isOff={isOff}>
          <ExpandButton isOff={isOff} onClick={expand}>
            <ExpandButtonHole isOff={isOff}>
              <ExpandButtonTop isOff={isOff}>expand</ExpandButtonTop>
            </ExpandButtonHole>
          </ExpandButton>
        </SectionButton>
      </SectionSub>
    </SectionMainContentClose>
  );
};

export default MachineSummary;
